import { z } from "zod"
import { dexieFirestoreDocument, FirestoreDocument } from "../../types/firestoreDocument"
import { optionalString } from "../../utils/validation/optionalString"

export type UserRole = "admin" | "young"

export interface User extends FirestoreDocument {
   role: UserRole
   email: string
   phone: string
   firstName: string
   lastName: string
   group: string
   photo: string
   contactsEmails: string[]
   contactsPhones: string[]
   notificationPreferences: {
      email: boolean
      sms: boolean
   }
   is_active: boolean
}

export const collectionName = "users"

export const dexieUser = dexieFirestoreDocument + ", role"

export const emailSchema = z.string().trim().email("Email invalide")

export const firstNameSchema = z.string().trim().min(1, "Le prénom est requis")

export const lastNameSchema = z.string().trim().min(1, "Le nom est requis")

export const phoneSchema = z
   .string()
   .trim()
   .min(10, "Le numéro de téléphone doit faire au moins 10 caractères")
   .regex(/^\d+$/, "Le numéro de téléphone doit contenir uniquement des chiffres")

export const contactEmailSchema = optionalString(emailSchema)
export const contactPhoneSchema = optionalString(phoneSchema)

export const init = () => {}
